module.exports = __webpack_public_path__ + "img/icon _truck_.5bd9cd67.svg";